import { createContext, RefObject } from "react";
import { FilterGroupProps } from "../FilterGroup";
import { Filter, FilterValue } from "./types";

/**
 * Context for sharing filter state and operations between FilterGroup and its children
 *
 * @extends FilterGroupProps
 */
type FilterGroupContextProps = FilterGroupProps & {
  /** Reference to the filter group DOM element
   *  @default { current: null }
   */
  filterGroupRef: RefObject<HTMLDivElement>;
  /** Current filters array
   *  @default []
   */
  filters: Filter[];
  /** Function to update a single filter and submit if needed
   *  @default () => {}
   */
  updateFilter: (filterId: string, value: FilterValue, submit: boolean) => void;
  /** Array of filters that are currently hidden due to overflow
   *  @default []
   */
  hiddenFilters: Filter[];
  /** Function to mark a filter as hidden
   *  @default () => {}
   */
  addHiddenFilter: (filter: Filter) => void;
  /** Function to mark a filter as visible
   *  @default () => {}
   */
  removeHiddenFilter: (filter: Filter) => void;
};

/**
 * Context provider for filter-related operations
 * Used to share filter state between FilterGroup and FilterDrawer
 */
export const FilterGroupContext = createContext<FilterGroupContextProps>({
  filterGroupRef: { current: null },
  filters: [],
  updateFilter: () => {},
  controlledFiltering: false,
  hiddenFilters: [],
  addHiddenFilter: () => {},
  removeHiddenFilter: () => {},
});
